<button class="btn text-white mb-myaccount-logout"
        mbOneClickAllowed
        [innerHTML]="'mbMyAccount.logout' | cxTranslate"
        (click)="onLogout()">
</button>
